import { render, staticRenderFns } from "./gameHeader.vue?vue&type=template&id=e4668150&scoped=true"
import script from "./gameHeader.vue?vue&type=script&lang=js"
export * from "./gameHeader.vue?vue&type=script&lang=js"
import style0 from "./gameHeader.vue?vue&type=style&index=0&id=e4668150&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4668150",
  null
  
)

export default component.exports